/** What a cell shows when it has no value — the table-wide empty indicator. */
export const EMPTY_CELL = '—';
